/**
 * Parses the DOM for cart line item quantity and bottle quantity values to
 * sum the number of wine bottles are in the order
 * @returns {number}
 */
function getCartTotalWineCount() {
    let totalWineCount = 0;
    const cartItems = document.querySelectorAll('[data-bottle-qty]');
    Array.from(cartItems).forEach(item => {
        const qtyElement = item.getElementsByClassName('quantity-input');
        const bottleQty = item.getAttribute('data-bottle-qty')
        if(qtyElement.length) {
            const qtyValue = parseInt(qtyElement[0].value, 10);
            totalWineCount = totalWineCount + (qtyValue * parseInt(bottleQty, 10));
        }
    });
    return totalWineCount;
}

/**
 * Evaluates the sum of wine bottles in the order, enables/disables 
 * the checkout button based on the minimum number of wine bottles needed,
 * and shows/hides the error container
 */
function runWineCountCheck() {
    const totalWineCount = getCartTotalWineCount();
    const checkoutButtonElement = document.getElementById('cartCheckout');
    if (checkoutButtonElement) {
        if(totalWineCount > 0 && totalWineCount < 4) {
            toggleBottleMinimumMessage(true, totalWineCount);
            checkoutButtonElement.disabled = true;
        } else {
            toggleBottleMinimumMessage(false, totalWineCount);
            checkoutButtonElement.disabled = false;
        }
    }
}

function toggleBottleMinimumMessage(show, bottleCount) {
    const bottleMinimumErrorElement = document.getElementById('bottle-min-qty-error');
    const bottleMinimumAmountElement = document.getElementById('bottle-min-qty-amount');
    // bail if the mini cart error container isn't there. This happens when there are zero items in cart
    if(!bottleMinimumErrorElement) {
        return;
    }
    if(show) {
        if(bottleCount < 3) {
            bottleMinimumAmountElement.innerHTML = `${4 - bottleCount} bottles`;
        } else {
            bottleMinimumAmountElement.innerHTML = '1 bottle';
        }
        bottleMinimumErrorElement.classList.add('active');
    } else {
        bottleMinimumErrorElement.classList.remove('active');
    }
}

// Run the check on page load.
runWineCountCheck();

// external_variant_id for the consultant subscription in recharge js events and api responses
const CONSULTANT_SUB_VARIANT_ID = '42289430790249';

// Listen for the recharge event for when a user clicks the "skip" option on a subscription
document.addEventListener('Recharge::click::skip', async (event) => {
    event.preventDefault();
    await checkRechargeSubscription(event);
});

// Listen for the cancellation flow trigger. The event carries the subscription name
// so no need to hit the API
document.addEventListener('Recharge::extension::cancellation_flow', async (event) => {
    const cancelFailModalElement = document.getElementById('recharge-modal-cancelfail');
    if (event.detail.subscription.external_variant_id === CONSULTANT_SUB_VARIANT_ID) {
        event.preventDefault();
        cancelFailModalElement.classList.add('active');
    }
});

/**
 * Call the recharge subscriptions api for subscription data. The events that recharge
 * sends only contain a subscription ID. The details have to be pulled from an api
 * lookup.
 */
async function checkRechargeSubscription(event) {
    const checkModalElement = document.getElementById('recharge-modal-skipcheck');
    const failModalElement = document.getElementById('recharge-modal-skipfail');
    checkModalElement.classList.add('active');
    const subscriptionInfo = await rechargeGetSubscription(event.detail.payload.subscriptionIds[0]);
    if (subscriptionInfo.external_variant_id.ecommerce === CONSULTANT_SUB_VARIANT_ID) {
        checkModalElement.classList.remove('active');
        failModalElement.classList.add('active');
        return false;
    } else {
        checkModalElement.classList.remove('active');
        document.dispatchEvent(new CustomEvent('Recharge::order::openSkipModal'));
    }
}

function closeRechargeModal(id) {
    const modal = document.getElementById(id);
    modal.classList.remove('active');
}

function initRechargeAutoAdd() {
    try {
        const params = new URLSearchParams(window.location.search);
        const productId = params.get('auto-add');
        if (!productId) return;

        const selector = `[data-rb-item-id="${productId}"]`;
        const MAX_WAIT_MS = 5000;

        const tryAutoAdd = () => {
        const productEl = document.querySelector(selector);
        if (!productEl) return false;

        const qtyInput = productEl.querySelector('input.rb-qty-input');
        const plusBtn = productEl.querySelector('.rb-btn-qty-plus');

        if (plusBtn) {
            plusBtn.click();
        } else if (qtyInput) {
            qtyInput.value = 1;
            qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        productEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        document.documentElement.style.scrollPaddingTop = '160px';

        return true;
        };

        if (tryAutoAdd()) return;

        const observer = new MutationObserver(() => {
        if (tryAutoAdd()) {
            observer.disconnect();
            clearTimeout(timeoutId);
        }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        const timeoutId = setTimeout(() => {
        observer.disconnect();
        }, MAX_WAIT_MS);
    } catch (e) {
        console.warn('Recharge auto-add failed:', e);
    }
}

document.addEventListener('DOMContentLoaded', initRechargeAutoAdd);
